import { Box, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function RepartitionInvestments({ report }) {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [revData, setRevData] = useState({
    // LAP-733 (GE022) — placeholder labels (overwritten by API on first load)
    labels: [
      t('investments.portfolio.repartition.defaults.salary'),
      t('investments.portfolio.repartition.defaults.passive'),
      t('investments.portfolio.repartition.defaults.other'),
    ],
    datasets: [
      {
        data: [80, 5, 15],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })
  const color = [
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
  ]
  useEffect(() => {
    setRevData({
      labels: report?.labels,
      datasets: [
        {
          data: report?.data,
          backgroundColor: color,
          borderColor: color,
          borderWidth: 1,
          hoverOffset: 4,
          precision: 0,
        },
      ],
    })
  }, [report, t, i18n.language]) // LAP-733 (GE022)
  const optiondonut = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    clip: true,
    cutout: '80%',

    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [value + '%']
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: false,
        events: [],
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.portfolio.repartition.title')}</Box>
          <Box ml={'auto'}>{report?.total} €</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          {/* LAP-733 (GE022) */}
          <Box sx={{ color: 'gray' }}>{t('investments.portfolio.repartition.subtitle')}</Box>
        </Box>
      </Box>
      <Box mt={1} height={'100%'} py={4}>
        {report?.labels.length > 0 ? (
          <Doughnut data={revData} options={optiondonut} />
        ) : (
          <Stack height="100%" alignItems="center" justifyContent="center">
            {/* LAP-733 (GE022) */}
            {t('investments.portfolio.noInvestmentsYet')}
          </Stack>
        )}
      </Box>
    </Box>
  )
}
